<template>
	<div>
		<fwb-card
			img-alt="Property Image"
			variant="image"
			class="w-full h-[367px] cursor-pointer"
		>
			<div class="w-full h-[184px] overflow-hidden">
				<div class="flex justify-between absolute px-4 py-3 w-auto">
					<div class="flex gap-1">
						<div>
							<span class="bg-custom_black2 flex text-white text-sm font-semibold rounded-md px-3 py-1 z-50">
								{{ props.data.type_property }}
							</span>
						</div>
						<div>
							<LabelTag
								:label="props.data.type_movement"
								:type_movement_id="props.data.type_movement_id"
							/>
						</div>
					</div>
				</div>
				<div 
					class="w-full h-52 overflow-hidden flex rounded-t-lg"
					:class="props.data.total_image == 0 ? 'justify-center items-center bg-[#f2f3f2]' : 'justify-end'"
				>
					<div>
						<div
							v-if="props.data.total_image > 0"
							class="w-full h-[184px] bg-cover bg-center"
							:alt="props.data.property_name"
						>
							<img
								:src="props.data.image"
								:alt="props.data.property_name"
								class="w-full object-cover h-150 rounded-t-lg"
							/>
						</div>

						<div v-if="props.data.total_image == 0">
							<img
								src="@/assets/imgs/default_image.svg"
								:alt="props.data.property_name"
								class="w-full h-28 object-cover rounded-t-lg"
							/>
						</div>
					</div>
				</div>
			</div>
			
			<div class="py-2 px-4 h-[181px] flex flex-col">
				<div class="flex justify-between">
					<div class="w-1/2">
						<span :class="[
							'text-xs font-medium rounded-md px-2.5 py-0.5',
							props.data.status_id === 1
								? 'bg-green-100 text-green-800'
							: props.data.status_id === 2
								? 'bg-gray-100 text-gray-800'
							: 'bg-yellow-100 text-yellow-800'
						]">
						{{ statusName }}
						</span>
					</div>
					<div class="w-1/2 text-right flex flex-col">
						<span class="text-[8px] text-custom_gray">ID de la propiedad</span>
						<span class="text-[10px] font-medium">{{ props.data.property_code}}</span>
					</div>
				</div>
				<div>
					<div class="w-full flex mt-2 h-5">
						<span
							v-if="props.data.is_owner != true"
							class="text-white bg-gray-800 rounded-lg text-xs font-normal px-2.5 py-0.5 inline-block max-w-full truncate overflow-hidden whitespace-nowrap"
						>
							<span class="font-medium">Asesor:</span>
							{{ props.data.agent_name}}
						</span>
					</div>
					
					<p 
						class="mt-2 text-base font-semibold text-black leading-5 tracking-tight property-title h-5 flex-1"
						:title="props.data.property_name"
					>
						{{ props.data.property_name }}
					</p>

					<p 
						class="flex items-center mt-2 text-xs font-normal text-black truncate overflow-hidden whitespace-nowrap"
						:title="props.data.property_address"
					>
						<img
							src="@/assets/imgs/icons/map-pin-outline.svg"
							alt="Ubicación"
							class="w-4 h-4 shrink-0"
						/>
						<span class="truncate overflow-hidden whitespace-nowrap block w-full">
							{{ props.data.property_address != ", , " ? props.data.property_address : "" }}
						</span>
					</p>
					
					<!-- Si es movimiento mixto (venta + renta) -->
					<div
						v-if="props.data.type_movement_id === 3"
						class="flex flex-col gap-1 text-black text-sm font-semibold mt-2"
					>
						<div>
							<span class="text-sm font-normal">Venta </span>{{ props.data.property_value }}
							<span class="text-xs font-normal"> {{ props.data.currency_code || props.data.currency }}</span>
						</div>
						<div>
							<span class="text-sm font-normal">Renta </span>{{ props.data.rent_value }}
							<span class="text-xs font-normal"> {{ props.data.currency_code || props.data.currency }}</span>
						</div>
					</div>
					<!-- Solo venta (1 o 5) -->
					<div
						v-else-if="props.data.type_movement_id === 1 || props.data.type_movement_id === 5 || props.data.type_movement_id === 2 || props.data.type_movement_id === 4"
						class="text-black text-sm font-semibold mt-2"
					>
						<span class="text-sm font-normal">{{ props.data.type_movement_name }} </span> {{ props.data.property_value }}
						<span class="text-xs font-normal">{{ props.data.currency_code || props.data.currency }}</span>
					</div>
				</div>
			</div>
		</fwb-card>
	</div>
</template>
<script setup>
import { computed } from 'vue'
import LabelTag from '@/commond/LabelTag.vue'
import { FwbCard } from 'flowbite-vue'

const props = defineProps({
  data: {
    type: Object,
    required: true
	},
})

const statusName = computed(() => {
  const statusMap = {
    1: 'Activada',
    2: 'Desactivada'
  }
  return statusMap[props.data.status_id] || 'Borrador'
})
</script>
<style scoped>
/* Custom styles if needed */
.property-title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>